{
  "el": {
    "todo_list": {
      "actions": {
        "add": "Δημιουργία λίστας εργασιών",
        "cancel": "Αναίρεση",
        "delete_todo_list": "Διαγραφή λίστας",
        "edit": "Επεξεργασία λίστας εργασιών",
        "new": "Λίστα εργασιών",
        "save": "Αποθήκευση",
        "title": "Τίτλος λίστας"
      },
      "attributes": {
        "name": "Τίτλος"
      },
      "labels": {
        "assignToLevel": "Ανάθεση σε επίπεδο",
        "createdAt": "Δημιουργήθηκε στις",
        "filter_employee": "Υπεύθυνος",
        "newTodoList": "Νέα λίστα εργασιών",
        "sort": {
          "created_at_asc": "Παλαιότερα πρώτα",
          "created_at_desc": "Νεότερα πρώτα",
          "name_lower_asc": "Όνομα Α → Ω",
          "name_lower_desc": "Όνομα Ω → Α"
        }
      },
      "phase_out": {
        "body": "Η λειτουργία Εργασίες (παλιά έκδοση) σταματά στο τέλος του 2026. Μετάφερε όσες εργασίες χρειάζεσαι ακόμα στις Εργασίες πριν από την 1η Ιανουαρίου 2027. Μέχρι τότε μπορείς να συνεχίσεις να χρησιμοποιείς και να ολοκληρώνεις τις υπάρχουσες εργασίες.",
        "title": "Οι Εργασίες (παλιά έκδοση) αποσύρονται"
      },
      "placeholders": {
        "empty": "Δεν υπάρχουν λίστες εργασιών εδώ"
      },
      "toasts": {
        "create": "Η λίστα εργασιών δημιουργήθηκε με επιτυχία",
        "delete": "Η λίστα εργασιών διαγράφηκε με επιτυχία",
        "update": "Η λίστα εργασιών ενημερώθηκε με επιτυχία"
      },
      "validation": {
        "needTitle": "Ο τίτλος είναι υποχρεωτικός"
      }
    }
  }
}
